import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Footer from "./components/Footer/Footer";
import InsuranceCard from "./components/Insurance/InsuranceCard";
import Home from "./pages/Home";
import Media from "./pages/Media";
import Insurance from "./pages/Insurance";
import Mutual_Funds from "./pages/Mutual_Funds";
import Profile from "./pages/Profile";
import Blog from "./pages/Blog";
import BlogsPage from "./pages/Blogs";
import NewBlog from "./pages/NewBlog";
import Loan from "./pages/Loan";
import ApplyInsurance from "./components/Insurance/ApplyInsurance";
import Education from "./pages/Education";
// import Pagination from "./components/Blogs/Pagination";
import Explore_MF from "./pages/Explore_MF";
import MF_Calculator from "./pages/MF_Calculator";
import Asset_Recorder from "./pages/Asset_Recorder";
import Profile_Page from "./components/Mutual_Funds/AssetRecorder/Profile";
import KeyPeople from "./components/Mutual_Funds/AssetRecorder/KeyPeople";
import BankAccount from "./components/Mutual_Funds/AssetRecorder/BankAccount";
import Bond from "./components/Mutual_Funds/AssetRecorder/Bonds";
import Locker from "./components/Mutual_Funds/AssetRecorder/Locker";
import FixedDeposit from "./components/Mutual_Funds/AssetRecorder/FixedDeposit";
import MutualFunds from "./components/Mutual_Funds/AssetRecorder/MutualFunds";
import EPF from "./components/Mutual_Funds/AssetRecorder/EPF";
import NPS from "./components/Mutual_Funds/AssetRecorder/NPS";
import PPF from "./components/Mutual_Funds/AssetRecorder/PPF";
import PMS from "./components/Mutual_Funds/AssetRecorder/PMS";
import AIF from "./components/Mutual_Funds/AssetRecorder/AIF";
import IndianEquity from "./components/Mutual_Funds/AssetRecorder/IndianEquity";
import USEquity from "./components/Mutual_Funds/AssetRecorder/USEquity";
import OffMarket from "./components/Mutual_Funds/AssetRecorder/OffMarket";
import RealEstate from "./components/Mutual_Funds/AssetRecorder/RealEstate";
import LifeInsurance from "./components/Mutual_Funds/AssetRecorder/LifeInsurance";
import HealthInsurance from "./components/Mutual_Funds/AssetRecorder/HealthInsurance";
import MotorInsurance from "./components/Mutual_Funds/AssetRecorder/MotorInsurance";
import Loans from "./components/Mutual_Funds/AssetRecorder/Loan";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import TermsOfUse from "./pages/TermsOfUse";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import Partner from "./components/Partner/Partner";

function routes() {
  const isLoggedIn = localStorage.getItem("authToken");

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/media" element={<Media />} />
        <Route path="/insurance" element={<Insurance />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/create-blog" element={<NewBlog />} />
        <Route path="/insurance-card" element={<InsuranceCard />} />
        <Route path="/loans" element={<Loan />} />
        <Route path="/insurance/apply" element={<ApplyInsurance />} />
        <Route path="/education" element={<Education />} />
        <Route path="/mutualfunds" element={<Mutual_Funds />} />
        <Route path="/mutualfunds/explore" element={<Explore_MF />} />
        <Route path="/mutualfunds/calculators" element={<MF_Calculator />} />
        <Route path="/mutualfund/assetreconciliation" element={<Asset_Recorder />} />
        <Route path="/user-profile" element={isLoggedIn ? <Profile /> : <Home />} />
        <Route path="/mutualfund/assetreconciliation/profile-page" element={<Profile_Page />} />
        <Route path="/mutualfund/assetreconciliation/key-people" element={<KeyPeople />} />
        <Route path="/mutualfund/assetreconciliation/bank-account" element={<BankAccount />} />
        <Route path="/mutualfund/assetreconciliation/locker" element={<Locker />} />
        <Route path="/mutualfund/assetreconciliation/fixed-deposit" element={<FixedDeposit />} />
        <Route path="/mutualfund/assetreconciliation/mutualfunds" element={<MutualFunds />} />
        <Route path="/mutualfund/assetreconciliation/bonds" element={<Bond />} />
        <Route path="/mutualfund/assetreconciliation/EPF" element={<EPF />} />
        <Route path="/mutualfund/assetreconciliation/NPS" element={<NPS />} />
        <Route path="/mutualfund/assetreconciliation/PPF" element={<PPF />} />
        <Route path="/mutualfund/assetreconciliation/PMS" element={<PMS />} />
        <Route path="/mutualfund/assetreconciliation/AIF" element={<AIF />} />
        <Route path="/mutualfund/assetreconciliation/indian-equity" element={<IndianEquity />} />
        <Route path="/mutualfund/assetreconciliation/US-equity" element={<USEquity />} />
        <Route path="/mutualfund/assetreconciliation/off-market" element={<OffMarket />} />
        <Route path="/mutualfund/assetreconciliation/real-estate" element={<RealEstate />} />
        <Route path="/mutualfund/assetreconciliation/life-insurance" element={<LifeInsurance />} />
        <Route path="/mutualfund/assetreconciliation/health-insurance" element={<HealthInsurance />} />
        <Route path="/mutualfund/assetreconciliation/motor-insurance" element={<MotorInsurance />} />
        <Route path="/mutualfund/assetreconciliation/loan" element={<Loans />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/partner" element={<Partner />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </BrowserRouter>
  );
}

export default routes;